import { render } from "./SaveAttachment.vue?vue&type=template&id=00bbd52a"
import script from "./SaveAttachment.vue?vue&type=script&lang=js"
export * from "./SaveAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__